import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/app/inner-reality-lens/InnerRealityLensClient.tsx");
